export default __webpack_public_path__ + "static/media/education-2.df16c71a.png";